export default __webpack_public_path__ + "static/media/camera.38f16423.svg";